export default "__VITE_ASSET__BMUbJLGV__"